import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import KeyDownEvent = JQuery.KeyDownEvent;

@Directive({
    selector: '[maximumEnforce]'
})
export class MaximumEnforceDirective {

    // Properties
    @Input() allowDecimal = false;
    @Input() maximumEnforce: number;

    private allowedKeys: Array<string> = [ 'Backspace', 'End', 'Home' ];
    private disallowedKeys: Array<string> = ['Tab', 'Space'];

    constructor(private el: ElementRef) {}

    @HostListener('keydown', [ '$event' ])
    onKeyDown(event: KeyDownEvent) {

        // Allow Backspace, end, and home keys
        if (this.allowedKeys.includes(event.key)) {
            return;
        }

        // Don't allow tab or space
        if (this.disallowedKeys.includes(event.key)) {
            event.preventDefault();
        }

        // Obtaining the new value
        let current: string = this.el.nativeElement.value;
        if (!current) {
            current = '';
        }
        const indexStart = event.target.selectionStart;
        const indexEnd = event.target.selectionEnd;
        const key = event.key;
        const next: string = current.slice(0, indexStart) + key + current.slice(indexEnd + Math.abs(0));
        const nextNumber: number = Number(next);

        // Checking the new value
        if (next
            && (this.allowDecimal || !next.includes('.'))
            && !isNaN(nextNumber)
            && parseFloat(next) <= this.maximumEnforce
        ) {
            return;
        }

        // Preventing if we haven't allowed it yet
        event.preventDefault();
        return;
    }
}
